import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CoreService } from '../core/core.service';
import { TransactionService } from './transaction.service';
import { Main } from '../core/main.service';

@Component({
  selector: 'cp-accounts',
  templateUrl: './accounts.component.html',
})

export class AccountsComponent {

  account: any = {};
  options: any;
  file: any;
  isLoading: any;
  id: string;
  accountForm!: FormGroup;
  config: any;
  operation: string;
  selectedSale: any;
  banks: any;

  filter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  sales: any[];
  accounts: any[];
  awards: any[];
  ekubMembers: any[];

  constructor(private route: ActivatedRoute,
    private formBuilder: FormBuilder, private mainService: Main, private api: TransactionService, private router: Router,
    @Inject(Restangular) public Restangular) {
    /*  this.account = {
       'bank': '',
       'position': 0,
       'remark': ''
     }; */
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.filter = '';
    this.isLoading = false;
    if (this.route.queryParams['value']['id']) {
      this.id = this.route.queryParams['value']['id'];
    }
    this.operation = 'add';
    this.banks = [
      { name: 'Abay Bank S.C', accronym: 'ABAY' },
      { name: 'Addis International Bank', accronym: 'ADIB' },
      { name: 'Awash International Bank', accronym: 'AWIN' },
      { name: 'Bank Of Abyssinia', accronym: 'BOA' },
      { name: 'Berhan International Bank', accronym: 'BERH' },
      { name: 'Bunna International Bank', accronym: 'BUNA' },
      { name: 'Commercial Bank of Ethiopia', accronym: 'CBE' },
      { name: 'Cooperative Bank of Oromia', accronym: 'COOP' },
      { name: 'Dashen Bank', accronym: 'DASH' },
      { name: 'Debub Global Bank', accronym: 'DEGA' },
      { name: 'Development Bank of Ethiopia', accronym: 'DVBE' },
      { name: 'Enat Bank', accronym: 'ENAT' },
      { name: 'Lion International Bank', accronym: 'LION' },
      { name: 'Nib International Bank', accronym: 'NIB' },
      { name: 'Oromia International Bank', accronym: 'OIB' },
      { name: 'United Bank', accronym: 'UNTD' },
      { name: 'Wegagen Bank', accronym: 'WEGA' },
      { name: 'ZamZam Bank', accronym: 'ZAMZ' },
      { name: 'Zemen Bank', accronym: 'ZEME' },
    ]
  }

  get account_number() { return this.accountForm.get('account_number'); }
  get bank() { return this.accountForm.get('bank'); }
  get accronym() { return this.accountForm.get('accronym'); }
  get status() { return this.accountForm.get('status'); }
  get remark() { return this.accountForm.get('remark'); }

  ngOnInit() {
    this.createForm();
    this.getAccounts();
  }


  getWinner(event: any) {
    debugger;
    const result = this.sales.filter(
      (sale: any) => sale.id.toLowerCase().indexOf(event.id.toLowerCase()) !== -1
    );
    this.selectedSale = result[0];
    this.getEkubMembers(result[0].award.data.ekub.data.id);
  }

  getEkubMembers(ekubId: any) {
    debugger;
    this.api.getEkubMembers(ekubId).subscribe((res: any) => {
      debugger;
      if (res.data) {
        this.ekubMembers = res.data;
        if (this.selectedSale) {
          var index = this.ekubMembers.map(x => {
            return x.id;
          }).indexOf(this.selectedSale.award.data.winner.data.id);
          this.ekubMembers.splice(index, 1);
        }
        for (let member of this.ekubMembers) {
          member.text = member.username;
          member.id = member.id;
        }
      }
    });
  }



  getAccounts() {
    debugger;
    this.api.getAccounts(this.currentPage, this.filter).subscribe((resp: any) => {
      debugger;
      this.accounts = resp.data;
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err) => {
      debugger;
      //this.coreService.addToast('Error', err.statusText);
    });
  }

  private createForm() {

    this.accountForm = this.formBuilder.group({
      account_number: ['', [Validators.required,]],
      accronym: ['', [Validators.required]],
      bank: ['', [Validators.required]],
      status: ['pending', [Validators.required]],
      remark: [''],
    });
  }

  getAccount() {
    this.api.getAccount(this.id).subscribe((res: any) => {
      debugger;
      this.account = res.data;
      this.accountForm.setValue(res.data);
    });
  }

  setAccronym(bank: any) {
    debugger;
    this.accronym.setValue(bank.accronym);
  }

  fileChange(event): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }

  changeStatus(id: any, status: any) {
    this.api.changeAccountStatus(id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getAccounts();
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

    });
  }

  addAccount() {
    debugger;
    this.isLoading = !this.isLoading;
    var id = this.account.id;
    this.bank.setValue(this.bank.value.name);
    this.account = this.accountForm.value;
    this.api.createAccount(this.account, id).subscribe((res: any) => {
      debugger;
      this.isLoading = !this.isLoading;
      this.accountForm.reset();
      this.getAccounts();
      this.mainService.toast({ title: 'Success', body: (this.id) ? 'Account successfully updated! ' : 'Account  successfully added!', type: 'dark' });
    }, (err) => {
      debugger;
      err = err;
      this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Error', body: (err.data.detail) ? err.data.detail : (this.id) ? 'Could not update account!' : 'Could not add account!', type: 'danger' });
    });
  }

  reset() {
    debugger;
    this.operation = 'add';
    this.accountForm.reset();
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getAccounts();
  }

  editAccount(account: any) {
    debugger;
    this.account = account;
    this.accountForm.get('account_number').setValue(account.account_number);
    this.accountForm.get('accronym').setValue(account.accronym);
    this.accountForm.get('bank').setValue(account.bank);
    this.accountForm.get('status').setValue(account.status);
    this.accountForm.get('remark').setValue(account.remark);
    this.operation = 'update';
  }

}
